import { cn } from '@/lib/utils';
import { CheckCircleIcon, ClockIcon, PhoneOffIcon, XCircleIcon } from 'lucide-react';

function getPhoneStatus(status: number) {
	if (status === 1) {
		return { label: 'Команда создана', icon: ClockIcon, className: 'text-chart-5', pulse: false };
	}
	if (status === 2) {
		return { label: 'Команда получена', icon: CheckCircleIcon, className: 'text-chart-2', pulse: false };
	}
	if (status === 3) {
		return { label: 'Ошибка', icon: XCircleIcon, className: 'text-destructive', pulse: false };
	}
	return { label: 'Нет номера', icon: PhoneOffIcon, className: 'text-muted-foreground', pulse: false };
}

interface PhoneStatusBadgeProps {
	status: number;
	className?: string;
}

export default function PhoneStatusBadge({ status, className }: PhoneStatusBadgeProps) {
	const meta = getPhoneStatus(status);
	const StatusIcon = meta.icon;

	return (
		<span
			className={cn(
				'inline-flex items-center gap-1 rounded-full border border-border bg-background/80 px-2 py-0.5 text-xs font-medium',
				meta.className,
				meta.pulse && 'animate-pulse',
				className,
			)}
		>
			<StatusIcon size={12} className={meta.pulse ? 'animate-spin' : undefined} />
			{meta.label}
		</span>
	);
}
